<template lang="pug">
div
  app-main-menu
    //- deafult menu items render here

  app-main-content
    h1 Civics
    h4 Content - WIP
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'Civics',
  setup() {
    return {
      // data
      input: ref(''),
      user: {},
    };
  },
});
</script>
